// Control amount of delay between closing event listeners firing
const delay = 200;
// Get header element to append the menu's to
const header = document.querySelector(".header");

// Get all elements with class 'header__menu-item'
const menuItems = document.querySelectorAll(".header__menu-item-parent");
// Get all mega menu elements
const menus = document.querySelectorAll(".header__mega-menu");

// Add hover event listener to each menu item
menuItems.forEach((menuItem) => {
  let menuTrigger = menuItem.getAttribute("data-menu-trigger");
  let menuEl = document.querySelector(
    '.header__mega-menu[data-mega-menu="' + menuTrigger + '"]'
  );

  // Store the setTimeout reference to clear if needed
  let timeout;

  menuItem.addEventListener("mouseenter", () => {
    // Hide all menu's so there is no overlapping
    menus.forEach((menu) => {
      menu.style.display = "none";
    });
    if (menuEl.classList.contains("mega-menu_mini")) {
      menuItem.appendChild(menuEl);
      menuEl.style.display = "block";
    } else {
      header.appendChild(menuEl);
      menuEl.style.display = "block";
    }
    clearTimeout(timeout);
  });

  // Hide the menu when the cursor has left the link.
  menuItem.addEventListener("mouseleave", () => {
    if (menuEl) {
      timeout = setTimeout(() => {
        if (!menuEl.matches(":hover")) {
          menuEl.style.display = "none";
        }
      }, delay);
    }
  });

  // Add event listener to check whether the menu is hovered
  if (menuEl) {
    menuEl.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
    });

    // Add event listener to check whether the menu is no longer hovered
    menuEl.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        if (!menuItem.matches(":hover")) {
          menuEl.style.display = "none";
        }
      }, delay);
    });
  }
});
